import { ProjectPhase } from "../../../../../../../constants/project-phase";
import { ServiceError } from "../../../../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, InformationBox, Modal, Row } from "../../../../../../../widget";
import { useCompletePhaseModal } from "./useCompletePhaseModal";

export const CompletePhaseModal = (): JSX.Element => {
  const {
    currentPhase,
    show,
    isStartDateInFuture,
    isHandleCompletePhaseLoading,
    errors,
    handleClose,
    handleCompletePhase,
    setShowEditDatesPanel,
  } = useCompletePhaseModal();

  return (
    <Modal show={show} title="Complete phase" onClose={handleClose}>
      {errors && errors.length > 0 && (
        <Row spacingV="ll">
          <Column offset={2} span={8}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleCompletePhase(e)}>
        {(currentPhase === ProjectPhase.ongoingMonitoring || isStartDateInFuture) && (
          <Row spacingV="l">
            <Column offset={2} span={8}>
              <InformationBox
                variant="alert"
                title="Warning"
                editText="Edit dates"
                onEdit={isStartDateInFuture ? () => setShowEditDatesPanel(true) : undefined}
              >
                <ul>
                  {currentPhase === ProjectPhase.ongoingMonitoring && (
                    <li>Completing the Ongoing monitoring phase will end the workflow</li>
                  )}
                  {isStartDateInFuture && (
                    <li>The start date of this phase is in the future, please refactor this in the edit dates panel</li>
                  )}
                </ul>
              </InformationBox>
            </Column>
          </Row>
        )}
        <Row spacingV="xl" justify="center">
          <Column span={10}>
            <p className="body1">
              Marking this phase as complete will lock its steps and tasks. You won’t be able to make changes after
              this.
            </p>
          </Column>
        </Row>
        <Row justify="center">
          <ActionButtons onCancel={handleClose} submitButtonLabel="Save" isLoading={isHandleCompletePhaseLoading} />
        </Row>
      </form>
    </Modal>
  );
};
